import {httpGet, httpPost} from "./api/axios_api";
import Constants from "../constants/constants";
import {player_game_session} from "./api/entities";

export const actions = {
    resetPlayerGameSessionState: "RESET_PLAYER_GAME_SESSION_STATE",
    createPlayerGameSession: "CREATE_PLAYER_GAME_SESSION",
    updatePlayerGameSession: "UPDATE_PLAYER_GAME_SESSION",
    listPlayerGameSessions: "LIST_PLAYER_GAME_SESSION",
    getPlayerGameSession: "GET_PLAYER_GAME_SESSION",

    addSessionsToList: "ADD_PLAYER_GAME_SESSIONS_TO_LIST",
    addPlayerGameSessionResultsToList: "ADD_PLAYER_GAME_SESSION_RESULTS_TO_LIST",
    getPlayerGameSessions: "GET_PLAYER_GAME_SESSIONS",
    resetPlayerGameSessionViewState: "RESET_PLAYER_GAME_SESSION_VIEW_STATE",
};

export function makeSessionActive(playerID, token, game_session_id) {
    let url = `${Constants.BACKEND_URL}/make-session-active/`;  
    let params = {
        "player_id": playerID,
        "game_session_id": game_session_id
    };
    
    let config = {
        params: params
    };

    return httpPost(url, config, token); 
}

export async function getPlayerGameSessionsAsync(playerID, token) {
    let url = `${Constants.BACKEND_URL}/get-player-assigned-game-sessions/${playerID}`;
    return httpGet(url, {}, token);  
}

export async function createPlayerGameSessionAsync(playerID, token, game_session_id) {
  let url = `${Constants.BACKEND_URL}/create-player-game-session`;
  let params = {
    "player_id": playerID,
    "game_session_id": game_session_id
  };

  let config = {
    params: params
  }

  return httpPost(url, config, token);
}

export async function playerHasSessions(playerID, token) {
    let url = `${Constants.BACKEND_URL}/player-has-sessions/${playerID}`;
    return httpGet(url, {}, token);
}

export async function getPlayerLastPlayedAssignedSession(playerID, token) {
  let url = `${Constants.BACKEND_URL}/get-player-last-played-assigned-session/${playerID}`;
  return httpGet(url, {}, token);
}

export function resetGameSessionViewState() {
  return {type: actions.resetPlayerGameSessionViewState}
}

export function resetPlayerGameSessionState() {
    return {type: actions.resetPlayerGameSessionState}
}

export function createPlayerGameSession(gameSessionObject) {
    return player_game_session.create(actions.createPlayerGameSession, gameSessionObject, []);
}

export function updatePlayerGameSession(playerGameSessionId, playerGameSessionObject) {
    return player_game_session.update(actions.updatePlayerGameSession, playerGameSessionId, playerGameSessionObject, []);
}

export function _getPlayerGameSessions(query, sort) {
    return player_game_session.list(actions.listPlayerGameSessions, query, sort);
}

export function getPlayerGameSession(game_sessionId) {
    return player_game_session.get(actions.getPlayerGameSession, game_sessionId, []);
}

export function getPlayerGameSessions(playerID, token) {
    return dispatch => {
        let url = `${Constants.BACKEND_URL}/get-player-game-sessions/${playerID}`;
        httpGet(url, {}, token).then((response) => {
            if (response.data.success) {
                dispatch({
                    type: actions.addSessionsToList,
                    player_game_sessions: response.data.player_game_sessions
                })
            }
            else {
                //TODO: handle results load error
            }

        })
    }
}

export function getPlayerGameSessionResults(playerGameSessionID, token) {
    return dispatch => {
        let url = `${Constants.BACKEND_URL}/get-player-game-session-results/${playerGameSessionID}`;
        httpGet(url, {}, token).then((response) => {
            if (response.data.success) {
                dispatch({
                    type: actions.addPlayerGameSessionResultsToList,
                    results: response.data.results
                })
            }
            else {
                //TODO: handle results load error
            }

        })
    }
}

const INITIAL_STATE = {
    should_get_player_game_sessions: true,
    should_get_player_game_session_view: true,
    player_game_sessions: [],
    player_game_session: {},
    current_game_session_results: []
};

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.resetGameSessionState:
            return {
                ...INITIAL_STATE
            };
        case actions.resetGameSessionViewState:
            return {
              ...state,
                current_game_session_results: [],
                should_get_player_game_session_view: true,
            };
        case actions.createGameSession:
            return {
                ...state,
                player_game_sessions: action.body ? [...state.game_sessions, action.body] : state.game_sessions
            };
        case actions.listPlayerGameSessions:
            return {
                ...state,
                player_game_sessions: action.body ? action.body._items : state.game_sessions
            };
        case actions.addPlayerGameSessionResultsToList:
            return {
                ...state,
                should_get_player_game_session_view: false,
                current_game_session_results: action.results ? action.results : []
            };
        case actions.getPlayerGameSession:
            return {
                ...state,
                player_game_session: action.body ? action.body : state.player_game_session
            };
        case actions.updatePlayerGameSession:
            return {
                ...state,
                id: action.body ? action.body : null
            };
        case actions.addSessionsToList:
            return {
                ...state,
                player_game_sessions: action.player_game_sessions,
                should_get_player_game_sessions: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/player_game_session.js